/**
 * A component that renders the tabs above the gallery view which allows to switch to other
 * galleries present in the chat config.
 */
import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import { getActiveModule, getModuleByRole } from "../../store";
import { goToModule } from "../../actions";
import { ModuleRoles } from "../../lib/types";
import { isNarrowScreen } from "../../lib/constants";
import { UserEventsAPI, UserEvents } from "../../lib/userEventsAPI";
import { getDigitalTours, getFloorPlans, getImages, getVideos } from "./selectors";

/**
 * Gallery Nav Bar component.
 */
class GalleryNavBar extends React.Component {
  /**
   * When user clicks on some link at the gallery navbar,
   * the user is redirected to another gallery module.
   * @param module
   */
  clickHandler = (module) => {
    const { dispatch } = this.props;
    dispatch(UserEventsAPI.send(UserEvents.GALLERY_TAB_SWITCHED));
    dispatch(goToModule(module.id));
  };

  render() {
    const {
      activeModule,
      galleryModule,
      floorPlansModule,
      advancedFloorPlansModule,
      videosModule,
      digitalToursModule,
      digitalTourContent,
      imageContent,
      floorPlanContent,
      videoContent,
    } = this.props;
    const items = [galleryModule, videosModule, digitalToursModule, floorPlansModule, advancedFloorPlansModule].filter(
      (module) => module
    );

    return (
      <>
        {items.length > 1 ? (
          <GalleryNavBarWrapper>
            <ul>
              {galleryModule && imageContent.length > 0 ? (
                <li
                  className={activeModule.isGallery() ? "active" : ""}
                  onClick={() => this.clickHandler(galleryModule)}
                >
                  <span>Photos</span>
                </li>
              ) : null}
              {videosModule && videoContent.length > 0 ? (
                <li className={activeModule.isVideo() ? "active" : ""} onClick={() => this.clickHandler(videosModule)}>
                  <span>Videos</span>
                </li>
              ) : null}
              {digitalToursModule && digitalTourContent.length > 0 ? (
                <li
                  className={activeModule.isDigitalTour() ? "active" : ""}
                  onClick={() => this.clickHandler(digitalToursModule)}
                >
                  <span>Tours</span>
                </li>
              ) : null}
              {floorPlansModule && floorPlanContent.length > 0 ? (
                <li
                  className={activeModule.isFloorplan() ? "active" : ""}
                  onClick={() => this.clickHandler(floorPlansModule)}
                >
                  <span>Floor Plans</span>
                </li>
              ) : null}
              {advancedFloorPlansModule ? (
                <li
                  className={activeModule.isAdvancedFloorplan() ? "active" : ""}
                  onClick={() => this.clickHandler(advancedFloorPlansModule)}
                >
                  <span>Floor Plans Map</span>
                </li>
              ) : null}
            </ul>
          </GalleryNavBarWrapper>
        ) : null}
      </>
    );
  }
}

/**
 * Gallery Nav Bar wrapper.
 */
const GalleryNavBarWrapper = styled.div`
  color: ${(props) => props.theme.brandColorLighter};
  font-size: ${() => (isNarrowScreen ? "14px" : "17px")};
  position: absolute;
  top: ${() => (isNarrowScreen ? "15px" : "30px")};
  left: ${() => (isNarrowScreen ? "15px" : "70px")};
  z-index: 2;

  ul {
    list-style: none;
    padding-inline-start: 0px;

    li {
      display: inline;
      padding: 15px;
      cursor: pointer;
      background: rgba(255, 255, 255, 0.4);

      &.active {
        color: ${(props) => props.theme.brandColor};
        span {
          border-bottom: 1px solid ${(props) => props.theme.brandColor};
          padding-bottom: 15px;
        }
      }
    }
  }
`;

/**
 * Map state to props.
 */
function mapStateToProps(state) {
  return {
    activeModule: getActiveModule(state),
    galleryModule: getModuleByRole(state, ModuleRoles.gallery),
    floorPlansModule: getModuleByRole(state, ModuleRoles.floorplan),
    advancedFloorPlansModule: getModuleByRole(state, ModuleRoles.advancedFloorplan),
    videosModule: getModuleByRole(state, ModuleRoles.video),
    digitalToursModule: getModuleByRole(state, ModuleRoles.digitalTour),
    digitalTourContent: getDigitalTours(state),
    imageContent: getImages(state),
    floorPlanContent: getFloorPlans(state),
    videoContent: getVideos(state),
  };
}
export default connect(mapStateToProps)(GalleryNavBar);
